
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

export enum BadgeColor {
    Primary = 'primary',
    Secondary = 'secondary',
}

export enum BadgeSize {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
}
@Component({
    selector: 'sirius-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-s-default' },
    imports: []
})
export class BadgeComponent {
    @Input() count = 0;
    @Input() color: BadgeColor = BadgeColor.Primary;
    @Input() size: BadgeSize = BadgeSize.XL;
    @Input() fontBold = false;

    BadgeColor = BadgeColor;
    BadgeSize = BadgeSize;

    @HostBinding('class.sir-one-digit')
    get isOneDigit(): boolean {
        return this.count < 10;
    }

    @HostBinding('class.sir-primary')
    get isPrimary(): boolean {
        return this.color === BadgeColor.Primary;
    }

    @HostBinding('class.sir-secondary')
    get isSecondary(): boolean {
        return this.color === BadgeColor.Secondary;
    }

    @HostBinding('class.sir-font-bold')
    get isFontBold(): boolean {
        return this.fontBold;
    }

    @HostBinding('class')
    get sizeClass(): string {
        return `sir-${this.size}`;
    }
}
